<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewRoles.title") }}</h3>

    <v-card
      class="mt-2"
      v-if="fetched && role != null"
      elevation="0"
      loading="!fetched"
    >
      <v-flex xs12 lg6>
        <v-form>
          <v-text-field
              outlined
            v-if="role.id > 0 || role.id === null"
            :disabled="role.id < 0"
            v-model="role.name"
            :error-messages="nameErrors"
            :label="$t('viewRoles.roleTitle')"
            required
            @input="$v.role.name.$touch()"
            @blur="$v.role.name.$touch()"
            @keyup.enter="submit"
          ></v-text-field>
          <v-text-field
            v-if="role.id < 0"
            disabled
            :value="$t('common.systemRolesNames.' + role.name)"
            :label="$t('viewRoles.roleTitle')"
            prepend-icon="fa-heading"
          ></v-text-field>
          <!--права роли-->
          <div>{{ $t("viewRoles.rights") }}:</div>
          <v-list v-if="fetched && role.all_rights">


                <v-select
                    v-for="(right, i) in rights"
                    xs6
                  clearable
                  outlined
                  v-model="role.all_rights[right.name]"
                  :items="rightsValues"
                  :label="$t('rightsNames.' + right.name)"
                >
                </v-select>


          </v-list>
          <v-divider class=""></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text mr-4 mt-5"
            color="red"
            :to="{ name: 'user-roles' }"
            elevation="0"
            :disabled="savingInProgress"
            :loading="savingInProgress"
          >
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            class="mt-5"
            elevation="0"
            color="primary"
            @click="submit"
            @keyup.enter="submit"
            :disabled="savingInProgress"
            :loading="savingInProgress"
          >
            {{ $t("common.save") }}
          </v-btn>
        </v-form>
      </v-flex>
    </v-card>
  </div>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  data: () => ({
    userRoles: {},
    dialog: false,
  }),
  created() {
    this.onLoad();
  },
  validations: {
    role: {
      name: { required },
    },
  },
  watch: {
    $route(to, from) {
      this.onLoad();
    },
  },
  computed: {
    ...mapState("rights", ["rights"]),
    ...mapState("roles", ["roles", "fetched", "role", "savingInProgress"]),

    nameErrors() {
      //return;
      const errors = [];
      if (!this.$v.role.name.$dirty) return errors;
      !this.$v.role.name.required &&
        errors.push(this.$t("form.validationErrors.field_is_required"));
      return errors;
    },
    rightsValues() {
      return [
        { text: this.$t("right.availableValues.0"), value: 0 },
        { text: this.$t("right.availableValues.1"), value: 1 },
        { text: this.$t("right.availableValues.2"), value: 2 },
      ];
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      if (this.$route.params.id) {
        this.$store.dispatch("roles/update");
      } else {
        this.$store.dispatch("roles/create").then((id) => {
          this.$router.push({ name: "user-role", params: { id: id } });
        });
      }
    },
    onLoad() {
      if (this.$route.params.id > 0 || this.$route.params.id < 0) {
        this.$store.dispatch("rights/getRights");
        this.$store
          .dispatch("roles/getRoleById", { id: this.$route.params.id })
          .then(() => {
            if (this.role === null) this.$router.push({ name: "404" });
          });
      } else {
        this.$store.dispatch("rights/getRights");
        this.$store.dispatch("roles/getNewRole");
      }
    },
  },
};
</script>
